module.exports = __webpack_public_path__ + "img/93.6f8ecc35.jpg";